import '../assets/css/header.css'
import '../assets/css/profile.css'
import { GrayCicrle , Phone , Cart ,User,Down_1,MiniExit,MiniLocation,MiniLock,MiniOrders,MiniUser,MiniWallet} from '../../assets/icones/icones';
import PlaceIcon from '@mui/icons-material/Place';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import React, {Fragment,useEffect, useRef, useState } from 'react';
import {Link, NavLink} from 'react-router-dom';

import clientconfigwebapp, {
  empty_bk,
  is_phone_hk,
  convert_to_english_strhk,
  scrollTo_uphk,
  show_menu_hh,
  check_login_appbk,
  modal_login_reg_bk_show,
  modal_login_reg_all_hide,
  FormatNumberByhkh,
  modal_select_agent_show_hide,
  Agent_by_user_get_appbk, modal_cart_show_hide,
} from '../../clientconfigwebapp';





import logo_web_app from '../../assets/images/logo-web-app.svg';
import Card_view from "../Cart_box/Card_view";
const Header = (props) => {
  const dropDown = useRef(null);
  const svg = useRef(null);
  const [theme , setTheme] = useState();
  const [name_show_agent , set_agent_name] = useState('انتخاب شعبه');

  useEffect(() => {
    if(document.body.classList.contains('dark')) {
      setTheme('dark')
    } else {
      setTheme('light')
    }

    var agent_name_bon=Agent_by_user_get_appbk("agent_name");

    if(!empty_bk(agent_name_bon)){
set_agent_name(agent_name_bon);

    }else{
      set_agent_name("انتخاب شعبه");
    }

    if (localStorage.getItem('themes_status')) {

      if(localStorage.getItem('themes_status')=="dark"){
        setTheme('dark');
        document.body.classList.remove('body');
        document.body.classList.add('dark');

      }else{
        setTheme('light');
        document.body.classList.remove('dark');
        document.body.classList.add('body');

      }

    }else{
      setTheme('light');
      document.body.classList.remove('dark');
      document.body.classList.add('body');

    }


  });

  const dropDownHandler = () => {
    dropDown.current.classList.toggle('active');
    console.log(svg.current);
    svg.current.classList.toggle('svg-active');

  }

  const themeHandler = () => {
    if(document.body.classList.contains('body')) {
      document.body.classList.remove('body');
      document.body.classList.add('dark');
      localStorage.setItem("themes_status","dark");

    } else {
      document.body.classList.remove('dark');
      document.body.classList.add('body');
      localStorage.setItem("themes_status","white");
    }


  }

  const Handler_login_show_bk = () => {
    modal_login_reg_bk_show("login_reg_check_view_modal");
  };

  const Handler_select_agent_show_bk = () => {
    modal_select_agent_show_hide("show");
  };

  const Handler_card_mobile_show_bk = () => {
    modal_cart_show_hide("show");
  };

  const Handler_card_mobile_hide_bk = () => {
    modal_cart_show_hide("hide");
  };

  const data_item_menu = [
    {
      path: '/panel/profile',
      title: 'اطلاعات من',
      icon: <MiniUser color={'var(--c7)'} />
    },
    {
      path: '/panel/my-address',
      title: 'آدرس‌های من',
      icon: <MiniLocation color={'var(--c7)'} />
    },
    {
      path: '/panel/wallet',
      title: 'کیف پول',
      icon: <MiniWallet color={'var(--c7)'} />
    },
    {
      path: '/panel/my-orders',
      title: 'سفارشات من',
      icon: <MiniOrders color={'var(--c7)'} />
    },
    {
      path: '/panel/change-password',
      title: 'تغییر رمز عبور',
      icon: <MiniLock color={'var(--c7)'} />
    },
    {
      path: '/login',
      title: 'خروج از حساب کاربری',
      icon: <MiniExit color={'var(--c7)'} />
    },
  ]

  return (
      <div>

      <div className="flexRowBetCenter w-100 header-container_bk">

        <div className="flexColStartStart">

    <div className="box-order-header-time">
    <span className="status-order-get">
    <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1rem" viewBox="0 0 15 15" fill="none"><circle cx="7.5" cy="7.5" r="7.5" fill="#979181"/></svg>
    <span style={{fontSize: 14, paddingRight: 6, color: "var(--c2)"}}>
    سفارش می‌پذیریم
    </span>
    </span>
    <span className="status-order-time">
    شنبه تا چهارشنبه <span style={{paddingRight: 3}}>7:45 تا 21:30</span>
    </span>
    <span className="status-order-time">
    جمعه ها<span style={{paddingRight: 3}}>10:15 تا 21:30</span>
    </span>
    </div>



          <div className={"box-right-header-mobile"} style={{width: "100%"}}>
            <button onClick={themeHandler} className="flexRowBetCenter btn-darck-light btn-icon-header"
                    style={{width: 46, height: 45}}>
              <svg width="" height="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                   style={{fill: "var(--c1)"}}>
                <g id="Dark">
                  <path
                      d="M12.741,20.917a9.389,9.389,0,0,1-1.395-.105,9.141,9.141,0,0,1-1.465-17.7,1.177,1.177,0,0,1,1.21.281,1.273,1.273,0,0,1,.325,1.293,8.112,8.112,0,0,0-.353,2.68,8.266,8.266,0,0,0,4.366,6.857,7.628,7.628,0,0,0,3.711.993,1.242,1.242,0,0,1,.994,1.963h0A9.148,9.148,0,0,1,12.741,20.917ZM10.261,4.05a.211.211,0,0,0-.065.011,8.137,8.137,0,1,0,9.131,12.526h0a.224.224,0,0,0,.013-.235.232.232,0,0,0-.206-.136A8.619,8.619,0,0,1,14.946,15.1a9.274,9.274,0,0,1-4.883-7.7,9.123,9.123,0,0,1,.4-3.008.286.286,0,0,0-.069-.285A.184.184,0,0,0,10.261,4.05Z"/>
                </g>
              </svg>
            </button>

            <a className={"btn-icon-header"} target={"_blank"} href={"tel:+982120000000"}>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                   style={{fill: "var(--c1)", width: 35, height: 31, position: "relative", top: 7, left: "-6px"}}>
                <path
                    d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z"
                    style={{fill: "var(--c1)"}} fill="#1C274C"/>
              </svg>
            </a>


          </div>


        </div>

        <div className="header__logo">
          <Link className={"hover-text-appbk"} to={"/"}> <img src={logo_web_app} alt={"Logo"}/></Link>
        </div>

        <div className="flexRowBetCenter">


          <div className={"box-icon-darck-light"} style={{width: "100%"}}>
            <button onClick={themeHandler} className="flexRowBetCenter btn-darck-light btn-icon-header"
                    style={{width: 46, height: 45}}>
              <svg width="" height="" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
                   style={{fill: "var(--c1)"}}>
                <g id="Dark">
                  <path
                      d="M12.741,20.917a9.389,9.389,0,0,1-1.395-.105,9.141,9.141,0,0,1-1.465-17.7,1.177,1.177,0,0,1,1.21.281,1.273,1.273,0,0,1,.325,1.293,8.112,8.112,0,0,0-.353,2.68,8.266,8.266,0,0,0,4.366,6.857,7.628,7.628,0,0,0,3.711.993,1.242,1.242,0,0,1,.994,1.963h0A9.148,9.148,0,0,1,12.741,20.917ZM10.261,4.05a.211.211,0,0,0-.065.011,8.137,8.137,0,1,0,9.131,12.526h0a.224.224,0,0,0,.013-.235.232.232,0,0,0-.206-.136A8.619,8.619,0,0,1,14.946,15.1a9.274,9.274,0,0,1-4.883-7.7,9.123,9.123,0,0,1,.4-3.008.286.286,0,0,0-.069-.285A.184.184,0,0,0,10.261,4.05Z" /></g></svg>
            </button>
          </div>




<a className={"btn-icon-header hide-mobile-bk"} target={"_blank"} href={"tel:+982120000000"}>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{fill: "var(--c1)", width: 35, height: 31, position: "relative", top: 7, left: "-6px"}}><path d="M16.5562 12.9062L16.1007 13.359C16.1007 13.359 15.0181 14.4355 12.0631 11.4972C9.10812 8.55901 10.1907 7.48257 10.1907 7.48257L10.4775 7.19738C11.1841 6.49484 11.2507 5.36691 10.6342 4.54348L9.37326 2.85908C8.61028 1.83992 7.13596 1.70529 6.26145 2.57483L4.69185 4.13552C4.25823 4.56668 3.96765 5.12559 4.00289 5.74561C4.09304 7.33182 4.81071 10.7447 8.81536 14.7266C13.0621 18.9492 17.0468 19.117 18.6763 18.9651C19.1917 18.9171 19.6399 18.6546 20.0011 18.2954L21.4217 16.883C22.3806 15.9295 22.1102 14.2949 20.8833 13.628L18.9728 12.5894C18.1672 12.1515 17.1858 12.2801 16.5562 12.9062Z" style={{ fill: "var(--c1)" }} fill="#1C274C"/></svg>
</a>

<a  href={clientconfigwebapp.webappurl + "checkout"}  className={"btn-cart-header hide-mobile-bk "}>
<Cart color={'var(--c4)'} />
</a>

<button onClick={Handler_card_mobile_show_bk}  className="flexRowBetCenter btn-icon-header hide-pc-bk show-flex-mobile-bk" style={{ width: 46, height: 45 }} >
  <Cart color={'var(--c4)'} />
</button>



          {

            check_login_appbk() === false ?

                <button type={"button"} onClick={Handler_login_show_bk} className='flexRowBetCenter btn-login-header' >
                  <User color={'var(--c7)'} /><span>ورود /  عضویت</span>
                </button>

              :
              <>
                <button className='flexRowBetCenter btn-login-header' onClick={dropDownHandler}>
                  <User color={'var(--c7)'} />
                  <span>{String(props.first_name_profile) + " "   + String(props.last_name_profile)}</span>
                  <span ref={svg}>
                    <Down_1 color={'var(--c7)'}  className='header-svg' />
                    </span>
                </button>




                <div className='user-menu-dropdown' ref={dropDown}>

                  <div className={"modal-bg-bk modal-bg-bk-menumob"}  onClick={ dropDownHandler }   ></div>

                  <div className="w-100 profile__container">


                    <div className="flexColStartStart w-100 profile__container__header">
                      <span className={"profile__container_name_user"}>{String(props.first_name_profile) + " "   + String(props.last_name_profile)}</span>
                      <div className='flexRowBetCenter w-100'>
                        <span className={"profile__container_title-wallet"}>اعتبار کیف پول</span>
                        <span className={"profile__container_title-wallet"}>

                          {  String(props.wallet_balance).length > 0 ?  (<Fragment>{FormatNumberByhkh(String(props.wallet_balance), ".", ",","t")}</Fragment> ) : (<Fragment>0 تومان</Fragment>)   }



                        </span>
                      </div>
                    </div>
                    <div className="flexColStartStart w-100 profile__container__body">
                      <ul className='w-100'>
                        { data_item_menu.map((item, index) => {
                              return (
                                  <li key={index} className='w-100 link-menu-mini'>
                                    <NavLink className={({isActive})=> isActive ? 'w-100 flexRowStartCenter pro-active' : 'w-100 flexRowStartCenter'} to={`${item.path}`}>
                                      {item.icon}
                                      <span>{item.title}</span>
                                    </NavLink>
                                  </li>
                              )
                            }
                        )}
                      </ul>
                    </div>
                  </div>



                </div>

              </>
          }








        </div>
      </div>


        <div onClick={Handler_select_agent_show_bk} className={"btn-change-location"}>

          <div className={"time-order-mobile"} >
            شنبه تا چهارشنبه <span style={{paddingRight: 3}}>7:45 تا 21:30</span>
          </div>

          <div style={{display: "flex"}}><PlaceIcon/><span>{name_show_agent}</span><KeyboardArrowDownIcon/></div>


          <div className={"time-order-mobile"}>
            جمعه ها <span style={{paddingRight: 3}}>10:15 تا 21:30</span>
          </div>
        </div>


        <div id={"modal_cart_mobile"} className={"cart-view-mobile-only"} style={{display: "none"}}>

        <div className={"card-container card-box-bk"}>
            <Card_view />
          </div>


        </div>


      </div>
  )
}
export default Header;